function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Color, PadMarg } from './../../enhancers';
import css from './Separator.sass';

function BaseSeparator(props) {
  var weight = props.weight,
      className = props.className,
      otherProps = _objectWithoutProperties(props, ["weight", "className"]);

  var classNames = cx(css.root, weight && css["weight-".concat(weight)], className);
  return React.createElement("div", _extends({
    className: classNames
  }, otherProps));
}
/* Adding enhancers */


var ColoredSeparator = function ColoredSeparator(props) {
  return React.createElement(Color, _extends({
    InputComponent: BaseSeparator
  }, props));
};

var Separator = function Separator(props) {
  return React.createElement(PadMarg, _extends({
    InputComponent: ColoredSeparator
  }, props));
};

BaseSeparator.propTypes = {
  /**
   * Separator weight
   */
  weight:
  /*#__PURE__*/
  PropTypes.oneOf(['1', '2', '3', '4', '5']),
  className: PropTypes.string
};
Separator.displayName = 'Separator';
Separator.defaultProps = {
  margin: 's',
  marginLeft: '0',
  marginRight: '0',
  marginLeftL: '0',
  marginRightL: '0',
  marginLeftM: '0',
  marginRightM: '0',
  marginLeftS: '0',
  marginRightS: '0',
  marginLeftXS: '0',
  marginRightXS: '0',
  color: 'grey',
  weight: '1'
};
export { Separator };